export const SHOW_MODAL_GIA_HAN_NOPHAITHU = "SHOW_MODAL_GIA_HAN_NOPHAITHU";
export const SHOW_MODAL_GIA_HAN_NOPHAITHU_SUCCESS =
  "SHOW_MODAL_GIA_HAN_NOPHAITHU_SUCCESS";
export const SHOW_MODAL_GIA_HAN_NOPHAITHU_FAILURE =
  "SHOW_MODAL_GIA_HAN_NOPHAITHU_FAILURE";

export const POST_GIA_HAN_NOPHAITHU = "POST_GIA_HAN_NOPHAITHU";
export const POST_GIA_HAN_NOPHAITHU_SUCCESS = "POST_GIA_HAN_NOPHAITHU_SUCCESS";
export const POST_GIA_HAN_NOPHAITHU_FAILURE = "POST_GIA_HAN_NOPHAITHU_FAILURE";
